/* eslint-disable no-plusplus */

export const calculateVisibleChips = ({
  containerElement,
  plusNWidth,
  chips,
  chipElement,
}) => {
  if (!containerElement || !chips.length) return 0;

  const containerWidth = containerElement.offsetWidth;
  let currentWidth = 0;
  let visibleCount = 0;

  const tempDiv = document.createElement('div');
  tempDiv.style.visibility = 'hidden';
  tempDiv.style.position = 'absolute';
  document.body.appendChild(tempDiv);

  try {
    for (let i = 0; i < chips.length; i++) {
      // eslint-disable-next-line no-template-curly-in-string
      tempDiv.innerHTML = chipElement.replace('${content}', chips[i]);
      const chipWidth = (tempDiv.firstChild as HTMLElement)?.offsetWidth ?? 0;

      const needsPlusN = i < chips.length - 1;

      if (
        currentWidth + chipWidth + (needsPlusN ? plusNWidth : 0) >
        containerWidth
      ) {
        break;
      }

      currentWidth += chipWidth;
      visibleCount++;
    }

    return visibleCount;
  } finally {
    document.body.removeChild(tempDiv);
  }
};

export const calculateVisibleChipsCount = ({
  containerElement,
  chipWidth,
  plusNWidth,
}) => {
  if (!containerElement || chipWidth <= 0) return 0;

  const containerWidth = containerElement.offsetWidth;
  let currentWidth = 0;
  let visibleCount = 0;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const needsPlusN = visibleCount > 0;

    if (
      currentWidth + chipWidth + (needsPlusN ? plusNWidth : 0) >
      containerWidth
    ) {
      break;
    }

    currentWidth += chipWidth;
    visibleCount++;
  }

  return visibleCount;
};
